import api from "../..";
import { SendRegistrantsMessageRequest } from "./types";

export const sendRegistrantsMessage = (data: SendRegistrantsMessageRequest): Promise<boolean> => {

  return api.post("/admin/home/send-registrants-message/", data)
  .then(() => true).
  catch(() => false);
};